import { State, ActionTypes } from './types';

const initialState: State = {
  services: [],
  service: null,
  searchResults: [],
  total: 0,
  isLoading: false,
  isUpdating: false,
  isCreating: false,
  updateError: null,
  createError: null
};

const servicesReducer = (state: State = initialState, action: any): State => {
  switch (action.type) {
    case ActionTypes.UPDATE_SERVICE:
      return {
        ...state,
        isUpdating: true,
        updateError: null
      };

    case ActionTypes.CREATE_SERVICE:
      return {
        ...state,
        isCreating: true,
        createError: null
      };

    case ActionTypes.GET_SERVICES:
    case ActionTypes.GET_SERVICE:
    case ActionTypes.SEARCH_SERVICES:
      return {
        ...state,
        isLoading: true
      };

    case ActionTypes.UPDATE_SERVICE_FAILURE:
      return {
        ...state,
        isUpdating: false,
        updateError: action?.error?.response?.data.error.text || 'An error occured'
      };

    case ActionTypes.CREATE_SERVICE_FAILURE:
      return {
        ...state,
        isCreating: false,
        createError: action?.error?.response?.data.error.text || 'An error occured'
      };

    case ActionTypes.GET_SERVICE_FAILURE:
    case ActionTypes.SEARCH_SERVICES_FAILURE:
    case ActionTypes.GET_SERVICES_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    case ActionTypes.GET_SERVICES_SUCCESS:
      const { data: services, pagination } = action.payload.data;
      return {
        ...state,
        services: services,
        total: pagination?.total,
        isLoading: false
      };

    case ActionTypes.GET_SERVICE_SUCCESS:
      const [responseService] = action.payload.data.data;
      return {
        ...state,
        service: responseService,
        isLoading: false
      };

    case ActionTypes.SEARCH_SERVICES_SUCCESS:
      return {
        ...state,
        searchResults: action.payload.data.data,
        isLoading: false
      };

    case ActionTypes.UPDATE_SERVICE_SUCCESS:
      const [updatedService] = action.payload.data.data;
      return {
        ...state,
        service: {
          // avatar_url field isn't returned from every PUT request, so it should be saved manually
          ...state.service,
          ...updatedService
        },
        isUpdating: false
      };

    case ActionTypes.CREATE_SERVICE_SUCCESS:
      return {
        ...state,
        isCreating: false,
        createError: null
      };

    case ActionTypes.CLEAR_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: []
      };

    case ActionTypes.CLEAR_UPDATE_ERROR:
      return {
        ...state,
        updateError: null
      };

    case ActionTypes.CLEAR_CREATE_ERROR:
      return {
        ...state,
        createError: null
      };

    default:
      return state;
  }
};

export default servicesReducer;
